module.exports = "../static/images/965858.png";